const mixin = {
  props: {
    section: {
      type: String,
      required: false,
    },

    subsection: {
      type: String,
      required: false,
    },

    municipality: {
      type: ()=>([]),
      required: false,
    },

    municipality_region_id: {
      type: [String, Number],
      required: false,
    },

    region: {
      type: [String, Number],
      required: false,
    },

    when: {
      type: [String, Number],
      required: false,
    },

    date: {
      type: [String, Number, Date],
      required: false,
    },

    organizer: {
      type: [String, Number],
      required: false,
    },

    age: {
      type: [String, Number],
      required: false,
    },

    rating: {
      type: [String, Number],
      required: false,
    },

    sort: {
      type: String,
      required: false,
    },

    is_pfdod: {
      type: [String, Number],
      required: false,
    },

    disease: {
      type: [String, Number],
      required: false,
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/pages/event/mixin-props.js